import { Component, StrictMode, useEffect, type ErrorInfo, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { AuthPage, DocsPage, LandingPage, PasswordRecoveryPage } from "./Marketing.js";
import { ProvisioningReviewPage } from "./ProvisioningReview.js";
import { PlatformSignerPage } from "./PlatformSigner.js";
import "./styles.css";
import "./marketing.css";
import "./provisioning.css";

const path = window.location.pathname.replace(/\/+$/, "") || "/";
const page = path === "/console/platform/onboarding"
  ? <ProvisioningReviewPage />
  : path === "/console/platform/signer"
    ? <PlatformSignerPage />
  : path.startsWith("/console")
    ? <App />
  : path === "/login"
    ? <AuthPage mode="login" />
    : path === "/forgot-password" || path === "/reset-password"
      ? <PasswordRecoveryPage />
    : path === "/signup" || path === "/signup/verify"
      ? <AuthPage mode="signup" />
      : path.startsWith("/docs")
        ? <DocsPage />
        : <LandingPage />;

class PageErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  override componentDidCatch(error: Error, info: ErrorInfo) { console.error("Sectigo Edge page failed", error, info); }
  override render() {
    if (!this.state.failed) return this.props.children;
    return <main className="fatal-page"><img src="/sectigo-logo.svg" alt="Sectigo" /><span>SECTIGO EDGE</span><h1>The console could not finish loading.</h1><p>Your trust data was not changed. Reload the console or return to the isolated product demo.</p><div><button onClick={() => location.reload()}>Reload console</button><a href="/console/demo">Open demo</a></div></main>;
  }
}

function HashScroller() {
  useEffect(() => {
    if (!location.hash) return;
    const id = decodeURIComponent(location.hash.slice(1));
    requestAnimationFrame(() => requestAnimationFrame(() => document.getElementById(id)?.scrollIntoView()));
  }, []);
  return null;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PageErrorBoundary><HashScroller />{page}</PageErrorBoundary>
  </StrictMode>,
);
